import api from "../../../api/flexapi";

export const GET_GLOBAL_MESSAGE_BOARD_START = "GET_GLOBAL_MESSAGE_BOARD_START";
export const GET_GLOBAL_MESSAGE_BOARD_SUCCESS = "GET_GLOBAL_MESSAGE_BOARD_SUCCESS";
export const GET_GLOBAL_MESSAGE_BOARD_ERROR = "GET_GLOBAL_MESSAGE_BOARD_ERROR";

export const HIDE_GLOBAL_MESSAGE_BOARD = "HIDE_GLOBAL_MESSAGE_BOARD";

export const globalMessageBoardKey = "globalMessageBoard";
export const hideMessageBoardKey = "hideMessageBoard";

export const getGlobalMessageBoard = () => dispatch => {
  dispatch({ type: GET_GLOBAL_MESSAGE_BOARD_START, payload: null });
  api
    .getGlobalMessageBoard()
    .then(res => {
      dispatch({
        type: GET_GLOBAL_MESSAGE_BOARD_SUCCESS,
        payload: res.body || {},
      });
      // res.body && localStorage.setItem(globalMessageBoardKey, JSON.stringify(res.body));
    })
    .catch(err => {
      dispatch({
        type: GET_GLOBAL_MESSAGE_BOARD_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const hideGlobalMessageBoard = () => dispatch => {
  //Time to Live is 1 day.
  const payload = { hideBoard: true, ttl: Date.now() + 24 * 60 * 60 * 1000 };
  dispatch({ type: HIDE_GLOBAL_MESSAGE_BOARD, payload: payload });
  localStorage.setItem(hideMessageBoardKey, JSON.stringify(payload));
};



// WEBPACK FOOTER //
// ./components/common/global-message-board/actions.js